import {
  ADDRESS_PAGE,
  BOILER_HOME_COVER,
  BROADBAND,
  CBC_CALC,
  DETAILS,
  ENERGY_DETAILS,
  ENERGY_TARIFF,
  INCOME_PROTECTOR,
  IN_LIFE_ENERGY_TARIFF,
  PARTNER,
  SAVE_FOR_LATER,
} from '@constants/formNames';
import {
  APPOINTMENT_ID,
  APPOINTMENT_TOKEN,
  APPOINTMENT_USER_ID,
  APPOINTMENT_USER_TYPE,
  ATTRIBUTION_TOKEN,
  BASKET_ID_KEY,
  COMPLETED_BASKET_ID_KEY,
  HOSTED_ID_KEY,
  SUBMITTED_ADDRESS_PAGE_VALUES,
  THANK_YOU_DETAILS_KEY,
} from '@constants/storageKeys';

const removeAppointmentFromLocalStorage = () => {
  localStorage.removeItem(APPOINTMENT_ID);
  localStorage.removeItem(APPOINTMENT_USER_ID);
  localStorage.removeItem(APPOINTMENT_USER_TYPE);
  localStorage.removeItem(APPOINTMENT_TOKEN);
};

const removeAddressSessionStorage = () => {
  sessionStorage.removeItem(SUBMITTED_ADDRESS_PAGE_VALUES);
  sessionStorage.removeItem(ADDRESS_PAGE);
};

const clearFormPersistStorage = () => {
  [
    ADDRESS_PAGE,
    BOILER_HOME_COVER,
    BROADBAND,
    DETAILS,
    ENERGY_DETAILS,
    ENERGY_TARIFF,
    IN_LIFE_ENERGY_TARIFF,
    INCOME_PROTECTOR,
    PARTNER,
    SAVE_FOR_LATER,
    SUBMITTED_ADDRESS_PAGE_VALUES,
    CBC_CALC,
  ].forEach((key) => sessionStorage.removeItem(key));
};

const clearBasketStorage = () => {
  sessionStorage.removeItem(BASKET_ID_KEY);
  localStorage.removeItem(BASKET_ID_KEY);
};

const completedBasketStorage = {
  isCompleted: (basketId: string) => {
    const completedBasketId = sessionStorage.getItem(COMPLETED_BASKET_ID_KEY);
    return completedBasketId === basketId;
  },
  setCompleted: (basketId: string) => {
    sessionStorage.setItem(COMPLETED_BASKET_ID_KEY, basketId);
  },
};

const attributionTokenStorage = {
  get: () => sessionStorage.getItem(ATTRIBUTION_TOKEN),
  set: (token: string) => sessionStorage.setItem(ATTRIBUTION_TOKEN, token),
  remove: () => sessionStorage.removeItem(ATTRIBUTION_TOKEN),
};

const hostedIdStorage = {
  get: () => sessionStorage.getItem(HOSTED_ID_KEY),
  set: (id: string) => sessionStorage.setItem(HOSTED_ID_KEY, id),
  remove: () => sessionStorage.removeItem(HOSTED_ID_KEY),
};

interface ThankYouDetails {
  primaryFirstName: string;
  hasJointAccountHolder: boolean;
  recentlyMovedIn: boolean;
}

const thankYouDetailsStorage = {
  get: (): ThankYouDetails | null => {
    const raw = localStorage.getItem(THANK_YOU_DETAILS_KEY);
    return raw ? (JSON.parse(raw) as ThankYouDetails) : null;
  },
  set: (data: ThankYouDetails) => {
    localStorage.setItem(THANK_YOU_DETAILS_KEY, JSON.stringify(data));
  },
  remove: () => localStorage.removeItem(THANK_YOU_DETAILS_KEY),
};

export {
  removeAddressSessionStorage,
  clearBasketStorage,
  clearFormPersistStorage,
  completedBasketStorage,
  removeAppointmentFromLocalStorage,
  attributionTokenStorage,
  hostedIdStorage,
  thankYouDetailsStorage,
};
